import { SVGProps, Ref, forwardRef } from 'react';

export const BackwardOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.51 7.143c2.03-.977 3.046-1.465 3.768-.91C12 6.79 12 8.06 12 10.597v2.806l-.001.894c-.01 1.95-.09 2.983-.72 3.47l-.14.091c-.62.347-1.461.028-2.914-.659l-.715-.342-2.92-1.403C1.53 13.983 0 13.247 0 12s1.53-1.983 4.59-3.454zm2.618.787c-.405.15-.967.415-1.839.835L5.37 10.168c-1.587.763-2.582 1.247-3.206 1.674q-.13.091-.213.158.082.067.213.158c.624.427 1.618.91 3.206 1.674l2.92 1.403c.871.42 1.433.683 1.838.834.068-.56.072-1.368.072-2.666v-2.806c0-1.298-.003-2.106-.072-2.667"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.51 7.143c2.03-.977 3.046-1.465 3.768-.91C24 6.79 24 8.06 24 10.597v2.806l-.001.894c-.01 1.95-.09 2.983-.72 3.47l-.14.091c-.62.347-1.461.028-2.914-.659l-.715-.342-2.92-1.403C13.53 13.983 12 13.247 12 12s1.53-1.983 4.59-3.454zm2.618.787c-.405.15-.967.415-1.839.835l-2.919 1.403c-1.588.763-2.582 1.247-3.206 1.674q-.13.091-.213.158.082.067.213.158c.624.427 1.619.91 3.206 1.674l2.92 1.403c.871.42 1.433.683 1.838.834.068-.56.072-1.368.072-2.666v-2.806c0-1.298-.003-2.106-.072-2.667"
                fill="currentColor"
            />
        </g>
    </svg>
));
BackwardOutlinedSize24Glyph.displayName = 'BackwardOutlinedSize24Glyph';
